import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { editReportVersionSectionRoute, editReportVersionSectionsRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { EditReportSectionForm } from "app/component/report-section/EditReportSectionForm";

export const EditReportVersionSectionScreen: FC = () => {
    const { reportId, versionId, sectionId } = useRouteParams(editReportVersionSectionRoute);
    const [updated, setUpdated] = useState(false);

    return updated ? (
        <Navigate to={editReportVersionSectionsRoute.build({ reportId, versionId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={editReportVersionSectionRoute} />
                <EditReportSectionForm sectionId={sectionId} onUpdate={() => setUpdated(true)} />
            </Container>
        </NavigationScreen>
    );
};
